import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IAppointments } from '../../../../services/availableTimes.service';
import { RootState } from '../../../../store';
import { clearCalendarSelected } from '../../../../features/calendar/calendar-slice';
import Addresses from './Addresses';
import { updateValidStep } from '../../../../features/stepper/stepper-slice';
import { saveSelectedDate } from '../../../../features/schedule/schedule-slice';

interface IAvailableAddressProps {
  appointments: IAppointments;
}

const AvailableAddress = ({ appointments }: IAvailableAddressProps) => {
  const dispatch = useDispatch();
  const {
    calendar: { calendarsAvailables, calendarSelected },
    schedule: { dateStart, selectedDay }
  } = useSelector((state: RootState) => state);

  const calendarWithOutAppointments = appointments.availableListAddress
    .filter(x => x[Object.keys(x)[0]].length === 0)
    .map(y => Object.keys(y)[0]);
  const physicalAppointments = calendarsAvailables.filter(
    item => item.calendarType === 'PHYSICAL_APPOINTMENT' && !calendarWithOutAppointments.includes(item.id)
  );
  const [availableAddress, setAvailableAddress] = useState<Record<string, boolean>>({});

  const findAvailableAddressByDate = (date: string) =>
    appointments.availableListAddress.reduce((acc: Record<string, boolean>, item: Record<string, string[]>) => {
      const calendarId = Object.keys(item)[0];
      if (item[calendarId].includes(date)) {
        acc[calendarId] = true;
      } else acc[calendarId] = false;
      return acc;
    }, {});

  useEffect(() => {
    setAvailableAddress(findAvailableAddressByDate(dateStart));
    if (calendarsAvailables.length > 1) {
      dispatch(clearCalendarSelected());
    }
  }, [dateStart]);

  useEffect(() => {
    if (dateStart.length > 0 && calendarSelected) {
      dispatch(updateValidStep({ schedule: true }));
    } else {
      dispatch(updateValidStep({ schedule: false }));
    }
  }, [calendarSelected, dateStart]);

  useEffect(() => {
    dispatch(saveSelectedDate(''));
    if (calendarsAvailables.length > 1) {
      dispatch(clearCalendarSelected());
    }
  }, [selectedDay]);

  return (
    <>
      {dateStart.length > 0 && physicalAppointments.length > 0 ? (
        <>
          <Addresses physicalAppointments={physicalAppointments} availability={availableAddress} />{' '}
        </>
      ) : (
        []
      )}
    </>
  );
};

export default AvailableAddress;
